/* Rquiere de mixin.js */

var transport = {
    data() {
        return {
            listTransports: [],
            methods: {
                transportGet: 'transports',
            },
            paginationTransports: [],
            searchTransports: '',
            loadingTransport: false,
            strTransport: [
                { result: 'Starken', strs: ['TUR BUS', 'TURBUS'] },
                { result: 'Correos de Chile', strs: ['CORREOS DE CHILE', 'CORREO DE CHILE', 'CORREOSDECHILE', 'CORREODCHILE'] },
                { result: 'Retira en ACES', strs: ['RETIRA DE ACES', 'RETIRA EN ACES', 'ACES', 'Santa Elena 1038'] },
            ],
            transportConfig: [
                {
                    transport_id: 2,
                    listAgencias: 'listStarkenAgencias',
                    listComunas: 'listStarkenComunas',
                    options: {
                        deliveryTypes: {
                            default: 2,
                            list: [
                                { id: 1, name: 'Agencia', paid_shipping: true, require_branch: true, office: 1 },
                                { id: 2, name: 'Domicilio', paid_shipping: true, require_branch: false, office: 0 },
                            ]
                        },
                        serviceTypes: {
                            default: 0,
                            list: [
                                { id: 0, name: 'Normal', list_delivery_types: [1, 2] },
                                { id: 1, name: 'Express', list_delivery_types: [1, 2] },
                            ]
                        }
                    }
                },
                {
                    transport_id: 3,
                    listAgencias: 'listCorreosChileSucursal',
                    listComunas: 'listCorreosChileComunas',
                    options: {
                        deliveryTypes: {
                            default: 2,
                            list: [
                                { id: 1, name: 'Agencia', paid_shipping: true, require_branch: true, office: 1 },
                                { id: 2, name: 'Domicilio', paid_shipping: false, require_branch: false, office: 0 },
                            ]
                        },
                        serviceTypes: {
                            default: 10,
                            list: [
                                { id: 10, name: 'Distribución Fisica', list_delivery_types: [1, 2] },
                                { id: 24, name: 'Paquete Express Domicilio', list_delivery_types: [2] },
                                { id: 7, name: 'Paquete Express Sucursal', list_delivery_types: [1] }
                            ]
                        }
                    }
                }
            ],
            
        }
    },
    computed: {
        listTransportsFilter() {
            this.listTransports.forEach(t => {
                let i = this.transportConfig.map((el) => parseInt(el.transport_id)).indexOf(parseInt(t.id))
                if(i > -1) {
                    t.config = this.transportConfig[i]
                }
            })
			return this.listTransports
		},
    },
    filters: {
    },
    methods: {
        getAllTransports(page = 1) {
            this.listTransports = []
            this.loadingTransport = true
            let parameters = '?search=' + this.searchTransports + '&page=' + page
            let url = this.getApiBackend + this.methods.transportGet + parameters
            this.axiosActionIS(url, 'GET', 'getAllTransportsResult')
        },
        getColorTransport(id) {
            let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            return (index > -1) ? this.listTransports[index].color : ''
        },
        getNameTransport(id) {
            let index = this.listTransports.map((el) => parseInt(el.id)).indexOf(parseInt(id))
            return (index > -1) ? this.listTransports[index].name : ''
        },
        getAllTransportsResult(response) {
            this.loadingTransport = false
            if (response.data.success == true) {
                this.listTransports = response.data.data
                this.paginationTransports = response.data.paginate
            }
            this.getAllTransportsResultLocal(response)
        },
        getAllTransportsResultLocal(response) {
            console.log('getAllTransportsResultLocal no desarrollado', response)
        },
        searchIdTransportsByStr(str) {
            let index = this.listTransports.map((el) => el.name.trim().toUpperCase()).indexOf(str.trim().toUpperCase())
            if (index == -1)
                return index
            return this.listTransports[index].id
        },
        selectTransporByStr(str) {
            let transport = { id: 0, name: '' }
            this.strTransport.forEach(s => {
                s.strs.forEach(st => {
                    if (st.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
                        str = s.result
                    }
                })
            })
            this.listTransports.forEach(t => {
                if (t.name.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, ""))) {
                    transport = t
                }
            });
            return transport
        }
    },
};

export default transport;